module.exports = {
  "Обязательное поле": "Міндетті жол",
  "Значение слишком короткое": "Мазмұны тым қысқа",
  "Значение слишком длинное": "Мазмұны тым ұзын",
  "Некорректный E-mail": "Қате E-mail",
  "Некорректный адрес сайта": "Сайттың мекенжайыңыз дұрыс емес",
  "Некорректные координаты": "Дұрыс емес координаттар",
  "Неправильный формат": "Қате формат",
  "Минимальное допустимое значение": "Минималды рұқсат етілген мән",
  "Максимальное допустимое значение": "Максималды рұқсат етілген мән",
  Время: "Уақыт",
  "Выберите ЭЦП": "ЭЦҚ таңдаңыз",
  "Введите пароль": "Құпиясөз енгізіңіз",
  "Выберите файл": "Файлды таңдаңыз",
  Ошибка: "Қате",
  "Размер файла не должен быть больше": "Файл өлшемі үлкен болмауы керек",
  "Количество загружаемого файла не должно быль больше": "Жүктелетін файлдың саны артық болмауы керек",
  Выбрать: "Таңдау",
  Выход: "Шығу",
  Места: "Орындар",
  "Председатель комиссии": "Комиссия төрағасы",
  Поставщики: "Ұйымдар",
  "Добавить председателя комиссии": "Комиссия төрағасын қосу",
  Редактировать: "Өңдеу",
  Сохранить: "Сақтау",
  "Скачать файл": "Файлды жүктеу",
  Посмотреть: "Көру",
  "Добавить новое место": "Жаңа орын қосу",
  "Отдел образования": "Білім бөлімі",
  "Организация образования": "Білім беру ұйымы",
  Пароль: "Құпиясөз",
  "Данные организации": "Ұйымның деректері",
  "Объявленные места": "Жарияланған орындар",
  "Загрузить файл": "Файлды жүктеу",
  Удалить: "Жою",
  "Удалить файла": "Файлды жою",
  "Вы действительно хотите удалить этот файл?": "Сіз бұл файлды шынымен жойғыңыз келе ме?",
  Отмена: "Болдырмау",
  "Родитель не хочет подписать табель?" : "Ата-ана қол қоюдан бас тартты ма?",
  'При нажатии кнопки "Да" ученик будет автоматически отчислен, а его табель на текущий месяц аннулирован. Это действие невозможно отменить. Вы уверены, что хотите продолжить?' : 
  '"Иә" батырмасын басқан кезде оқушы автоматты түрде оқудан шығарылады және оның ағымдағы айдағы табелі жойылады. Бұл әрекетті қайтару мүмкін емес. Сіз жалғастырғыңыз келетініне сенімдісіз бе?',
  Изменить: "Өзгерту",
  ОК: "ОК",
  "Вы действительно хотите удалить эту запись?": "Сіз бұл жазбаны шынымен жойғыңыз келе ме?",
  Филиалы: "Филиалдар",
  Сотрудники: "Қызметкерлер",
  "Удалить запись": "Жазбаны жою",
  Местонахождение: "Орналасқан жері",
  Координаты: "Координаттары",
  "Председатели комиссии": "Комиссия төрағалары",
  // "": "",
  place: "Конкурс туралы хабарландыру",
  commision: "Комиссия төрағасы",
  organization: "Ұйымдар",
  apply: "Конкурсқа қатысушылар",
  plan: "Білім беру оқу жоспары",
  staff: "Қызметкерлер",
  branch: "Филиалдар",
  training: "Жетілдіру курстары",
  "Учебные программы": "Оқу жоспарлары",
  "Вход в кабинет": "Жүйеге кіру",

  "Объявление о конкурсе": "Конкурс туралы хабарландыру",
  Черновики: "Шимайлар",
  Опубликованные: "Жарияланған",
  Отозванные: "Кері қайтарып алынған",
  Архив: "Мұрағат",
  Новые: "Жаңа",
  Допущенные: "Өткізілген",
  "Не допущенные": "Өткізілмеген",
  "Данные устарели": "Деректер ескірген",
  Заблокированные: "Бұғатталған",
  "На рассмотрении": "Қарастырылуда",
  Поданные: "Тапсырған",
  Подано: "Жiберiлдi",
  Одобрено: "Мақұлданды",
  Отказано: "Қабылданбады",
  Отозвано: "Қайтарып алынды",
  Одобренные: "Мақұлданған",
  Отказанные: "Қабылданбады",
  "Группы госзаказ": "Мемлекеттік тапсырыс топтары",
  "Группы платные": "Ақылы топтар",
  Расписание: "Кесте",
  "Список учеников": "Оқушылар тізімі",
  "Курсы повышения": "Арттыру курстары",
  КТП: "КТЖ",
  Зарегистрировано: "Тіркелген",
  "Отказано в регистрации": "Тіркеуден бас тартылды",
  Войти: "Кіру",
  "Вход в кабинет Управление Образования": "Білім басқармасының кабинетіне кіру",
  "Вход в кабинет Отдел Образования": "Білім бөлімінің кабинетіне кіру",
  "Вход в кабинет Отдел Образования для комиссии": "Комиссия үшін білім бөлімінің кабинетіне кіру",
  "Вход в кабинет / Регистрация Организации": "Ұйым кабинетіне кіру/тіркелу",
  "Вход в кабинет / Регистрация Сотрудника Организации": "Ұйым қызметкері кабинетіне кіру/тіркелу",
  Главная: "Басты бет",
  "Организации образования": "Білім беру ұйымдары",
  "Секции, кружки и занятия": "Секциялар, үйірмелер және сабақтар",
  "Подать заявление": "Өтініш жіберу",
  Продолжить: "Жалғастыру",
  Сегодня: "Бүгін",
  "Доблировать на следующую неделю": "Келесі аптаға көшірме жасау",
  "Доблировать до конца обучения": "Оқу жылының соңына дейін көшірме жасау",
  Закрыть: "Жабу",
  "За неделю": "Апта ішінде",
  "За день": "Күніне",
  Проверить: "Тексеру",
  "Как это работает": "Бұл қалай жұмыс істейді",
  "С нами удобно": "Бізбен ыңғайлы",
  Руководитель: "Ұйым басшысы",
  "Управление Образования": "Білім басқармасы",
  Родитель: "Ата-ана",
  "Отдел Образования": "Білім бөлімі",
  Сотрудник: "Қызметкер",
  "Платформа для дополнительного образования": "Қосымша білім беруге арналған платформа",
  "Язык обучения": "Оқыту тілі",
  "Показатели посещаемости": "Қатысу көрсеткіштері",
  Дата: "Күні",
  "Добавить ребенка": "Баланы қосу",
  Создать: "Қосу",
  ФИО: "ТАӘ",
  Пол: "Жынысы",
  Мужской: "Ұл",
  Женский: "Қыз",
  "Дата рождения": "Туған күні",
  ИИН: "ЖСН",
  Дети: "Балалар",
  "Все курсы": "Барлық үйірмелер",
  "Государственные школы": "Мемлекеттік мектептер",
  "Гос журнал": "Сынып журналы",
  "Мои заявки": "Менің өтініштерім",
  "Мои курсы / Журнал": "Менің үйірмелерім / Журнал",
  Акты: "Актілер",
  "Сертификат выдается:": "Сертификат беріле ме:",
  "Стоимость:": "Құны",
  Бесплатно: "Тегін",
  "Адрес:": "Мекен-жай:",
  "Статус:": "Мәртебесі:",
  "Тип:": "Типі",
  "Материальная техническая база": "Материалдық техникалық базасы",
  "Выигранные конкурсы": "Жеңімпаз конкурстар",

  Группы: "Топтар",
  "Гос Заявки": "Класс өтініштері",
  "Гос Журналы": "Класс журналдары",

  "Праздничные дни": "Мерекелік күндер",
  Заявки: "Өтінімдер",
  Журналы: "Журналдар",
  Замечания: "Ескертулер",
  "Распределение по группам": "Топқа бөлу",
  Профиль: "Профиль",
  "Активный профиль": "Белсенді профиль",
  Экзамены: "Емтихан",
  "Журнал инструктажа": "Нұсқаулық журналы",
  Табели: "Табельдер",
  "Достижения обучающихся": "Оқушылардың жетістіктері",
  "Журнал учета работы педагога": "Мұғалімнің жұмыс журналы",
  "Учебная нагрузка педагога": "Педагогтың оқу жүктемесі",
  Филиал: "Филиал",
  "Сведения о детях": "Балалар туралы ақпарат",
  Организации: "Ұйымдар",
  "К вашему аккаунту не привязаны дети. Обратитесь к администратору школы.": "Сіздің аккаунтыңызға бала тіркелмеген. Мектеп әкімшілігімен байланысыңыз.",
  Нет: "Жоқ",
  Да: "Иә",
  "Мангистауская область": "Маңғыстау облысы",
  "Актау Г.А.": "Ақтау Қ.А.",
  "Жанаозен Г.А.": "Жаңаөзен Қ.А.",
  "Каракиянский район": "Қарақия ауданы",
  "Мангистауский район": "Маңғыстау ауданы",
  "Мунайлинский район": "Мұнайлы ауданы",
  "Тупкараганский район": "Түпқараған ауданы",
  "Бейнеуский район": "Бейнеу ауданды",
  Все: "Барлық",
  Поиск: "Іздеу",
  "По направлению курса": "Курс бағыты бойынша",
  "По региону курса": "Аймақ бойынша",

  Уведомление: "Хабарландыру",
  Уважаемый: "Құрметті",
  "cообщаем Вам, что Ваш ребенок": "cіздің балаңыз",
  "отчислен из группы": "топтан шығарылған - ",
  "Отчисление произведено": "Аударым жасалды",
  "С уважением": "Құрметпен",
  Ознакомился: "Мен таныстым",

  "Уважаемые пользователи платформы!": "Құрметті платформа пайдаланушылары!",
  "Обращаем ваше внимание на необходимость отправки всех технических запросов, связанных с платформой, на электронный адрес support.edus.kz. Пожалуйста, при составлении письма выберите по какому проекту пишете, укажите тему, опишите суть проблемы. Все запросы подлежат автоматической предварительной обработке перед передачей операторам. Поэтому, без правильно сформулированного, рассмотрение будет невозможным. Срок ответа составляет до 5 рабочих дней. Спасибо за понимание.":
    "Біз барлық техникалық жіберу қажеттілігіне назар аударамыз электрондық пошта арқылы платформаға қатысты сұраулар support.edus.kz. Хат жазғанда, қай жоба туралы жазып жатқаныңызды таңдаңыз, тақырыпты көрсету, мәселенің мәнін сипаттау. Барлық сұраулар автоматты түрде орындалады операторларға беру алдында алдын ала өңдеу. Сондықтан, онсыз дұрыс тұжырымдалса, қарастыру мүмкін болмайды. Жауап беру уақыты 5 жұмыс күніне дейін. Назарларыңызға рахмет.",

  "Гос организации": "Мемлекеттік ұйымдар",
  "Художественные школы (Дворец школьников)": "Өнер мектептері (Оқушылар сарайы)",
  "Дополнительные клубы": "Аула клубтары",
  Классы: "Класстар",
  "Журнал учета работы": "Жұмысты есепке алу журналы",

  "Удостоверение личности РК": "ҚР Жеке куәлігі",
  "Паспорт РК": "ҚР Паспорты",
  "ВНЖ РК": "ҚР ШТЫ",
  "МВД РК": "ҚР ІІМ",
  "МЮ РК": "ҚР ӘМ",
  "Орган выдачи": "Берген орган",
  "Тип документа": "Құжат түрі",

  "Поиск по карте": "Карта бойынша іздеу",
  Заявление: "Өтініш",
  "Прошу уведомлять меня об изменениях моего заявления следующими способами:": "Өтінішімнің өзгеруі туралы маған келесі тәсілдермен хабарлаңыз:",
  "электронное смс (sms) - уведомление в произвольной форме на следующие номера мобильных телефонов (не более двух номеров):":
    "электронды смс (sms) - келесі ұялы телефон нөмірлеріне еркін түрде хабарлама (екі нөмірден аспауы керек):",
  "электронные e-mail уведомления в произвольной форме:": "еркін нысандағы хабарламалар электрондық поштаға:",
  "Согласие на обработку персональных данных": "Дербес деректерге қол жеткізуге келісімі",
  
  "Только для поставщиков!" : "Тек қана ұйымдар үшін!",
  "Уважаемые пользователи! Уведомляем вас, что с 1 августа 2024 года платформа дополнительного образования Zerek EDUS начинает переход на годовое платное обслуживание, предоставляемое на договорной основе для частных поставщиков. Просим вас связаться с ответственным менеджером проекта Zerek EDUS для получения дополнительной информации." : "Құрметті қолданушылар! Zerek EDUS қосымша білімге арналған платформасы 1-ші тамыз 2024 ж. бастап жеке меншік білім орталықтарымен келісім-шарт түріндегі жылдық ақылы қызмет көрсету түріне көшуді бастайтындығын хабарлаймыз. Толық ақпарат алу үшін Zerek EDUS жоба менеджерімен байланысуыңызды сұраймыз.",
  "Здравствуйте! Хотел бы обратиться по вопросу платного обслуживания Zerek EDUS для получения дополнительной информации." : "Сәлеметсіз бе! Zerek EDUS қосымшасы бойынша ақылы қызмет көрсетуге көшу туралы толығырақ ақпарат білу мақсатында хабарласып тұрмын.",
  "Написать" : "Байланыс",
  "Замечания и объявления" : "Ескертулер мен хабарландырулар",
  "Объявление о вакансии" : "Жұмыс туралы хабарландыру",
  "Техподдержка" : "Техқолдау",
  "Государственные организации" : "Мемлекеттік ұйымдар",
  "Справки" : "Анықтамалар",
  "Обьявление о частных уроках" : "Жеке сабақ туралы хабарландыру",
  "Для регистрации детей необходимо отправить SMS (СМС) на ваш зарегистрированный номер в Базе мобильных граждан (БМГ). Для этого нажмите кнопку «Отправить» и далее отправьте ответное сообщение SMS в виде кода, обозначающего ответ «Да» (511 или 521)." : "Балаларды тіркеу үшін Мобильдік азаматтар базасында (МАБ) тіркелген нөміріңізге, SMS (СМС) жіберілуі қажет.Ол үшін «Жіберу» батырмасын басыңыз, әрі қарай нөміріңізге жіберілген хабарламаға «Иә» деген жауапты білдіретін код түрінде SMS жауап қайтарыңыз (511 немесе 521).",
  'По цене курса' : "Оқу ақысы бойынша",
  'По организации' : "Ұйым бойынша",
  "months": {
    "january": "Қаңтар",
    "february": "Ақпан",
    "march": "Наурыз",
    "april": "Сәуір",
    "may": "Мамыр",
    "june": "Маусым",
    "july": "Шілде",
    "august": "Тамыз",
    "september": "Қыркүйек",
    "october": "Қазан",
    "november": "Қараша",
    "december": "Желтоқсан"
  },
  "Всего учащихся" : "Барлық оқушылар саны",
  "Январь" : "Қаңтар",
  "Февраль" : "Ақпан",
  "Март" : "Наурыз",
  "Апрель" : "Сәуір",
  "Май" : "Мамыр",
  "Июнь" : "Маусым",
  "Июль" : "Шілде",
  "Август" : "Тамыз",
  "Сентябрь" : "Қыркүйек",
  "Октябрь" : "Қазан",
  "Ноябрь" : "Қараша",
  "Декабрь" : "Желтоқсан",
  "Выберите год" : "Жылды таңдаңыз",
  "Дата:" : "Күні:",
  "Время:" : "Уақыты:",
  "Преподаватель:" : "Мұғалім:",
  "Добавить урок" : "Сабақ қосу",
  "Урок" : "Сабақ",
  "Добавить новый урок" : "Жаңа сабақ қосу",
  "Время начала" : "Басталу уақыты",
  "Время окончания" : "Аяқталу уақыты",
  "Продолжительность урока должна быть от 20 минут до 2 часа" : "Сабақтың ұзақтығы 20 минуттан 2 сағатқа дейін болуы керек",
  "Один или несколько выбранных дней уже содержат урок" : "Бір немесе бірнеше таңдалған күндерде сабақ бар",
  "Урок успешно удален" : "Сабақ сәтті жойылды",
  "Ошибка при удалении урока" : "Сабақты жою кезінде қате",
  "Ошибка при обновлении данных" : "Деректерді жаңарту кезінде қате",
  "Ошибка при сохранении урока" : "Сабақты сақтау кезінде қате",
  "Можно выбрать не более 12 дат для добавления уроков" : "Сабақтарды қосу үшін 12-ден артық күнді таңдауға болмайды",
  "Выберите хотя бы одну дату" : "Кем дегенде бір күнді таңдаңыз",
  "Общее количество уроков не должно превышать 12" : "Сабақтардың жалпы саны 12-ден аспауы керек",
  "Подробнее" : "Толығырақ",
  "Обьявления скрыты" : "Хабарландырулар жасырын",
  "Показать" : "Көрсету",
  "Пожалуйста, подождите..." : "Күте тұрыңыз...",
  "Идет загрузка данных" : "Деректер жүктелуде",
  "Загрузка данных..." : "Деректер жүктелуде...",
  "Нет данных для отображения" : "Көрсету үшін деректер жоқ",
  "(Стандартный) Строк на странице:" : "(Стандартты) Беттегі жолдар:",
  "Начать урок" : "Сабақты бастау",
  "Редактирование оценки" : "Бағаны өзгерту",
  "Оценка" : "Баға",
  "Месяц и год" : "Ай және жыл",
  "Номер документа:" : "Құжат нөмірі",
  "Полный адрес организации:" : "Ұйымның толық мекен-жайы",
  'Название филиала:' : 'Филиал атауы',
  'Название группы:' : 'Топтың атауы',
  'Название категории:' : 'Санат атауы',
  'Название подкатегории:' : 'Ішкі санат атауы',
  'Ф.И.О.:' : 'Т. А. Ә.',
  'Статус документа:' : 'Құжат мәртебесі',
  'Причина отказа: ' : 'Бас тарту себебі: ',
  "Рабочих дней" : "Сабақ күндері",
  "Всего посещений" : "Қатысу саны",
  "Нагрузка в день" : "Күндік жүктеме",
  "Итого часов" : "Сағат саны",
  " час" : " сағат",
  'Родитель отклонил табель. Вы можете изменить оценки и отправить снова' : "Ата-ана табельді қабылдамады. Сіз бағаларды өзгертіп, қайта жібере аласыз",
  'Подписать табель' : "Табельді жіберу",
  'Откатить табель' : "Табельді қайтару",
  'Если табель отправлен в отдел образования или закрыт, его невозможно откатить' : "Егер табель білім бөліміне жіберілсе немесе жабылса, оны қайтару мүмкін емес",
  'Сначала измените оценки' : "Алдымен бағаларды өзгертіңіз",
  "Откатить табель?" : "Табельді қайтару?",
  'При нажатии кнопки "Да" табель будет удалён, а подписи родителей аннулированы. Это действие необратимо. Вы уверены, что хотите продолжить?' : '"Иә" батырмасын басқан кезде табель және ата-аналардың қолы кері қайтарылады. Бұл әрекетті қайтару мүмкін емес. Сіз жалғастырғыңыз келетініне сенімдісіз бе?',
  'Пожалуйста, выберите оценку' : "Бағаны таңдаңыз",
  'Вы удаляете урок, который уже пройден. В этом случае урок будет удален вместе с оценками за этот день. Это действие необратимо. Вы уверены, что хотите продолжить?' : "Сіз өткен сабақты жойып жатырсыз. Бұл жағдайда сабақ осы күннің бағаларымен бірге жойылады. Бұл әрекетті қайтару мүмкін емес. Сіз жалғастырғыңыз келетініне сенімдісіз бе?",
  'Предупреждение': "Ескерту",
  'Для государственных служащих' : "Мемлекеттік қызметкерлерге",
  "Управление образования": "Білім басқармасы",
  "Учитель": "Мұғалім",
  'Вы пользователь платформы?' : "Сіз платформа пайдаланушысыз ба?",
  'Войдите в свой аккаунт для доступа к сервисам' : "Қызметтерге қол жеткізу үшін өз аккаунтыңызға кіріңіз",
  'Войти как пользователь' : "Қолданушы ретінде кіру",
  'Вы государственный служащий?' : "Сіз мемлекеттік қызметкерсіз бе?",
  'Войдите в систему для государственных служащих' : "Мемлекеттік қызметкерлер жүйесіне кіріңіз",
  'Войти как сотрудник' : "Қызметкер ретінде кіру",
  'Для пользователей платформы' : "Платформа пайдаланушыларына",
  "Главная страница": "Басты бет",
  "Документы": "Құжаттар",
  "Очереди": "Кезектер",
  "Гос образовательный заказ": "Мемлекеттік қосымша білім тапсырысы",
  "Гос спортивный заказ": "Мемлекеттік спорттық тапсырысы",
  "Гос творчественный заказ": "Мемлекеттік шығармашылық тапсырысы",
  
  "groups": {
    "createGroupButton": "Топ құру",
    "createGroupTitle": "Жаңа топ құру",
    "groupType": "Топ түрі",
    "stateOrder": "Мемлекеттік тапсырыс",
    "languageOfStudy": "Оқу тілі",
    "teacher": "Оқытушы",
    "approvedQuantity": "Бекітілген саны",
    "freePlaces": "Бос орындар",
    "placeType": "Орын түрі",
    "placesCount": "Орындар саны",
    "groupNameRu": "Топ атауы (орысша)",
    "groupNameKk": "Топ атауы (қазақша)",
    "cost": "Құны",
    "trainingStartDate": "Оқу басталу күні",
    "trainingEndDate": "Оқу аяқталу күні",
    "clubCategory": "Топтың санаты",
    "clubSubcategory": "Топтың ішкі санаты",
    "branch": "Филиал",
  },
  "common": {
    "branch": "Филиал",
    "address": "Мекен-жай",
    "course": "Курс",
    "places": "Орындар",
    "fullName": "Аты-жөні",
    "position": "Лауазымы",
    "status": "Статусы",
    "noData": "Дерек жоқ",
    "cancel": "Болдырмау",
    "create": "Құру",
    "selectClubCategory": "Топ санатын таңдаңыз",
    "selectClubSubcategory": "Топтың ішкі санатын таңдаңыз",

    "search": "Іздеу",
    "select": "Таңдау",
    "actions": "Әрекеттер"
  },
  "validation": {
    "selectGroupType": "Топ түрін таңдаңыз",
    "selectStateOrder": "Мемлекеттік тапсырысты таңдаңыз",
    "selectLanguage": "Оқу тілін таңдаңыз",
    "selectTeacher": "Оқытушыны таңдаңыз",
    "enterGroupName": "Топ атауын енгізіңіз",
    "selectPlaceType": "Орын түрін таңдаңыз",
    "enterPlacesCount": "Орындар санын енгізіңіз",
    "placesCountPositive": "Орындар саны оң сан болуы керек",
    "enterCost": "Құнды енгізіңіз",
    "costNonNegative": "Құн теріс болмауы керек",
    "enterStartDate": "Басталу күнін енгізіңіз",
    "enterEndDate": "Аяқталу күнін енгізіңіз",
    "endDateAfterStart": "Аяқталу күні басталу күнінен кейін болуы керек",
    "selectClubCategory": "Топ санатын таңдаңыз",
    "selectClubSubcategory": "Топтың ішкі санатын таңдаңыз",
    "selectBranch": "Филиалды таңдаңыз",
    "selectTabels": "Табельдерді таңдаңыз",
    "selectYear": "Жылды таңдаңыз",
    "selectMonth": "Айды таңдаңыз",
    "invoiceFileRequired": "Шот-фактураны жүктеңіз",
    "invoiceMustBePdf": "Шот-фактура PDF форматында болуы керек",
    "invoiceFileTooLarge": "Шот-фактура файлы тым үлкен"
  },
  "errors": {
    "loadGroupTypes": "Топ түрлерін жүктеу кезінде қате",
    "failedLoadGroupTypes": "Топ түрлерін жүктеу сәтсіз аяқталды",
    "loadStateOrders": "Мемлекеттік тапсырыстарды жүктеу кезінде қате",
    "failedLoadStateOrders": "Мемлекеттік тапсырыстарды жүктеу сәтсіз аяқталды",
    "loadLanguages": "Тілдерді жүктеу кезінде қате",
    "failedLoadLanguages": "Тілдерді жүктеу сәтсіз аяқталды",
    "loadTeachers": "Оқытушыларды жүктеу кезінде қате",
    "failedLoadTeachers": "Оқытушыларды жүктеу сәтсіз аяқталды",
    "loadPlaceTypes": "Орын түрлерін жүктеу кезінде қате",
    "failedLoadPlaceTypes": "Орын түрлерін жүктеу сәтсіз аяқталды",
    "groupCreateFailed": "Топты құру сәтсіз аяқталды",
    "loadCategories": "Санаттарды жүктеу кезінде қате",
    "failedLoadCategories": "Санаттарды жүктеу сәтсіз аяқталды",
    "loadSubCategories": "Ішкі санаттарды жүктеу кезінде қате",
    "failedLoadSubCategories": "Ішкі санаттарды жүктеу сәтсіз аяқталды",
    "loadBranches": "Филиалдарды жүктеу кезінде қате",
    "failedLoadBranches": "Филиалдарды жүктеу сәтсіз аяқталды",
    "actCreateFailed": "Актіні құру сәтсіз аяқталды",
    "invoiceUploadFailed": "Шот-фактураны жүктеу кезінде қате"
  },
  "messages": {
    "groupCreatedSuccess": "Топ сәтті құрылды",
    "actCreatedSuccess": "Акт сәтті құрылды",
    "invoiceUploadSuccess": "Шот-фактура сәтті жүктелді"
  },
  "Акт оказанных услуг": "Көрсетілген қызметтер актісі",
  "Новый": "Жаңа",
  "Оператор (Культура)": "Оператор (Шығармашылық)",
  "Назад": "Кері қайту",
  "Количество мест:" : "Орындар саны:",
  "Образовательный план" : "Қосымша білім жоспары",
  "Спортивный план" : "Спорттық жоспар",
  "Творческий план" : "Шығармашылық жоспар",
  "Выберите организацию" : "Ұйымды таңдаңыз",
  "Распределение студентов по полу" : "Оқушыларды жынысы бойынша бөлінуі",
  "Учителя" : "Мұғалімдер",
  "Заявки на обучения" : "Оқу өтініштері",
  "Студенты с социальной поддержкой" : "Әлеуметтік қолдау көрсетілетін студенттер",
  "Одобренные заявки в конкурсе" : "Конкурста мақұлданған өтініштер",
  "Распределение групп" : "Топтардың бөлінуі",
  "Все заявки" : "Барлық өтініштер",
  "Название" : "Атауы",
  "Регион" : "Аудан",
  "Имя организации" : "Ұйым атауы",
  "ФИО директора" : "Директордың ТАӘ",
  "Действия" : "Таңдау",
  "Мальчики" : "Ұлдар",
  "Девочки" : "Қыздар",
  "Частные группы" : "Жеке топтар",
  "Гос. группы" : "Тапсырыспен оқытылатын топтар",
  "Не принятые заявки" : "Қабылданбаған өтініштер",
  "Принятые заявки" : "Қабылданған өтініштер",
  "Отчисленные заявки" : "Оқудан шығарылған өтініштер",
  "Из них" : "Олардың ішінде",
  "девочки" : "қыздар",
  "Активный контингент" : "Белсенді контингент саны",
  "гос. группы" : "тапсырыспен оқытылатын топтар",
  "женщины" : "әйелдер",
  "учен. на 1 учитель" : "оқушы 1 мұғалімге",
  "принята" : "қабылданды",
  "сейчас обучаются" : "қазір оқып жатыр",
  "Одобренные места" : "Мақұлданған орындар cаны",
  "Полный адрес организаций:" : "Ұйымның толық мекен-жайы:",
  "Учитель:" : "Мұғалім:",
  "Название группы" : "Топ атауы",
  "Занято мест" : "Орындар саны",
  "Категория" : "Санаты",
  "Подкатегория" : "Ішкі санаты",
  "Одобренное количество мест" : "Бекітілген орын саны",
  "Язык" : "Тілі",
  "Выбор преподавателя" : "Мұғалімді таңдаңыз",
  "Поиск преподавателя" : "Мұғалімді іздеу",
  "Должность" : "Лауазымы",
  "Статус" : "Мәртебесі",
  "Адрес филиала" : "Филиалдың мекен-жайы",
  "Макс. количество" : "Макс. саны",
  "Категория клуба" : "Топтың санаты",
  "Подкатегория клуба" : "Топтың ішкі санаты",
  "Утвержденное количество" : "Бекітілген орын саны",
  "Свободные места" : "Бос орындар",
  "Объявления" : "Хабарландыру",
  "Наименование организаций:" : "Ұйым атауы:",
  "БИН организаций:" : "Ұйымның БСН:",
  "Подтвердить" : "Қабылдау",
  "Отклонить" : "Бас тарту",
  "Новые организации" : "Жаңа ұйымдар",
  "Допущенные организации" : "Мақұлданған ұйымдар",
  "Не допущенные организации" : "Қабылданбаған ұйымдар",
  "Заблокированные организации" : "Бұғатталған ұйымдар",
  "Данные по регионам" : "Аудандар бойынша ақпарат",
  "Один преподаватель может проводить уроки в разных районах, поэтому общее количество преподавателей может быть завышено." : "Бір оқытушы әртүрлі аудандарда сабақ өткізе алады, сондықтан жалпы оқытушылар саны артық болып көрінуі мүмкін.",
  "Один студент может числиться в нескольких группах, что влияет на общее число активных контингентов." : "Бір студент бірнеше топта тіркелуі мүмкін, бұл жалпы белсенді контингент санына әсер етеді.",
  "График распределения филиалов" : "Филиалдардың аудан бойынша графигі",
  "Преподаватели" : "Оқытушылар",
  "Контингенты" : "Контингент",
  "Выберите регион" : "Ауданды таңдаңыз",
  "Данные по категориям группы" : "Топ санаттары бойынша ақпарат",
  "Данные по социальным категориям" : "Әлеуметтік санаттар бойынша ақпарат",
  "Студенты" : "Студенттер",
  "Студенты в базе" : "Дерекқордағы студенттер",
  "Частные организации" : "Жеке ұйымдар",
  "Название филиала" : "Филиал атауы",
  "Выбрать все" : "Барлығын таңдау",
  "Родители" : "Ата-аналар",
  "Класс" : "Сынып",
  "Для регистрации ребёнка в системе. На ваш номер телефона, зарегистрированный в системе БМГ, будет отправлено SMS-сообщение от номера 1414. Вам необходимо положительно ответить на это сообщение, отправив код (чаще всего 511), и подтвердить согласие на получение данных ребёнка из базы ГБД ФЛ для системы АИС EDUS." : "Сіздің МАБ жүйесінде тіркелген телефон нөміріңізге 1414 нөмірінен SMS-хабарлама жіберіледі. Сіз бұл хабарламаға оң жауапты кодты (көбінесе 511) жіберу арқылы жауап қайтарып, АБЖ EDUS жүйесі үшін ЖТ МДҚ дерекқорынан баланың деректерін алуға келісім беруіңіз қажет.",
  "Эти действия необходимы для проверки подлинности данных ребёнка и участия в государственных программах, а также для предотвращения появления “мертвых душ” в системе." : "Бұл әрекеттер баланың деректерінің шынайылығын және оның мемлекеттік бағдарламаларға қатысуға құқығын тексеру үшін, сондай-ақ жүйеде “жалған балалардың” пайда болуын болдырмау мақсатында жүзеге асырылады.",
  "Все ваши данные надежно защищены и обрабатываются в соответствии с законодательством Республики Казахстан о защите персональных данных." : "Сіздің барлық деректеріңіз Қазақстан Республикасының дербес деректерді қорғау туралы заңнамасына сәйкес қауіпсіз және құпия түрде қорғалады.",
  "К вашему аккаунту не привязаны дети." : "Сіздің аккаунтыңызға бала тіркелмеген.",
  "act": {
    "tabels": "Табельдер",
    "year": "Жыл",
    "month": "Ай",
    "branch_name": "Филиал",
    "teacher_full_name": "Мұғалім",
    "group_name": "Топ",
    "status_name": "Мәртебесі",
    "place_count": "Орын саны",
    "signed_count": "Қол қойылған",
    "last_updated_at": "Соңғы жаңарту",
    "selectedCount": "Таңдалған жазбалар: {count}",
    "createActButton": "Акт құру",
    "createActTitle": "Жаңа акт құру",
    "branch": "Филиал",
    "tabelsSelected": "табель таңдалған",
    "invoiceFile": "Шот-фактура (PDF)",
    "uploadingInvoice": "Шот-фактура жүктелуде...",
    "invoiceUploaded": "Шот-фактура жүктелді"
  },
  "Выигранные заявки в конкурсе" : "Конкурста жеңіп алынған өтінімдер"
};
